// extracted by mini-css-extract-plugin
export default {"checkbox":"MyCheckbox_checkbox__+3hPT","checkbox_invisible":"MyCheckbox_checkbox_invisible__3AQFW"};